import React from "react"
import autobind from "class-autobind"
import { Dialog, TextField, FlatButton, CircularProgress } from "material-ui"
import { TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import Table from "../../../components/common/Table"
import strings from "../../../localization/strings"
import Clear from "../../../components/misc/Clear"
import AccountStore from "../../../stores/AccountStore"
import AppStateStore from "../../../stores/AppStateStore"
import { IOccupationInfo, IOccupation } from "../../../models"
import * as api from "../../../api"

interface IProps {
	handleClose(): void
	handleSave(Occupations: IOccupationInfo[]): void
}
interface IState {
	OccupationsList: IOccupation[]
	selectedOccupations: IOccupationInfo[]
	search: string
	loading: boolean
	total: number
	offset: number
	limit: number
}
const styles = {
	nameCol: {
		paddingLeft: 5,
		paddingRight: 5,
		cursor: "pointer"
	},
	otherCol: {
		paddingLeft: 5,
		paddingRight: 5,
		width: 75
	}
}

export default class ChooseOccupationDialogForChip extends React.Component<IProps, IState> {
	private Occupations: IOccupation[]
	constructor(props) {
		super(props)
		this.Occupations = []
		this.state = {
			OccupationsList: [],
			selectedOccupations: [],
			search: "",
			loading: false,
			total: 0,
			offset: 0,
			limit: 8,
		}
		autobind(this)
	}

	componentDidMount() {
		this.getOccupationsList()
	}

	getOccupationsList() {
        this.setState({ loading: true }, () => {
			api.getAccountHRISOccupations(AccountStore.getCurrentAccount().Id)
			.then(res => {
				this.Occupations = res.data.filter(occupation => occupation.Active) as IOccupation[]
				this.setState({
					OccupationsList: this.Occupations.slice(0, this.state.limit),
					total: this.Occupations.length,
					loading: false
				})
			})
			.catch(_err => {
				this.Occupations = []
				this.setState({
					OccupationsList: [],
					total: this.Occupations.length,
					loading: false
				}, () => AppStateStore.setProgressSnackbarContent(strings.something_went_wrong))
			})
		})
	}
	
	// Updating the List for Client-Side Pagination & Searching
	updateOccupationList() {
		const filteredList = this.Occupations.filter(item => !this.state.search || item.Name.toLowerCase().includes(this.state.search.toLowerCase())).filter((_v, index) => index >= this.state.offset && index < this.state.offset + this.state.limit)
		if (this.state.search !== "") this.setState({ OccupationsList: filteredList, total: filteredList.length })
		else this.setState({ OccupationsList: filteredList, total: this.Occupations.length })
	}
	
	handleSelectOccupations(selectedOccupations) {
		selectedOccupations = selectedOccupations.slice().map(occupation => (
			{
				Id: occupation.Id,
				Name: occupation.Name,
			}
		))
		this.setState({ selectedOccupations })
	}

	OccupationsTable = () => (
		!this.state.OccupationsList.length ?
			<h2 style={{ textAlign: "center", marginTop: 25 }}>
			{strings.No_Occupation_Found}
			</h2> :
		<Table
			items={this.state.OccupationsList}
			handleSelect={this.handleSelectOccupations}
			total={this.state.total}
			offset={this.state.offset}
			limit={this.state.limit}
			limitOptions={[8, 20, 50]}
			onPageClick={offset => this.setState({ offset }, () => this.updateOccupationList())}
			onLimitChange={limit => this.setState({ offset: 0, limit }, () => this.updateOccupationList())}
		>
			<TableHeader>
				<TableRow>
					<TableHeaderColumn style={styles.nameCol}>{strings.Name}</TableHeaderColumn>
				</TableRow>
			</TableHeader>
			<TableBody showRowHover deselectOnClickaway={false}>
				{this.state.OccupationsList.map((item, index) =>
					<TableRow key={index} selected={this.state.selectedOccupations.find(occupation => occupation.Id === item.Id) ? true : false}>
						<TableRowColumn style={styles.nameCol} title={item.Name}>{item.Name}</TableRowColumn>
					</TableRow>
				)}
			</TableBody>
		</Table>
	)

	render() {
		return (
			<Dialog
				autoScrollBodyContent
				modal
				open
				title={strings.Choose_Occupations}
				actions={[
					<FlatButton
						label={strings.Cancel}
						secondary
						onClick={this.props.handleClose}
					/>,
					<FlatButton
						label={strings.OK}
						primary
						keyboardFocused
						disabled={this.state.selectedOccupations.length > 0 ? false : true}
						onClick={() => {
							this.props.handleSave(this.state.selectedOccupations)
						}}
					/>
				]}
				onRequestClose={this.props.handleClose}
			>
				<div style={{ padding: 20, paddingLeft: 35 }}>
					<i style={{ fontSize: 25 }} className="fa fa-search" />
					<TextField
						hintText={strings.search}
						style={{ marginRight: 20, width: "90%", marginLeft: 15 }}
						value={this.state.search}
						onChange={e => this.setState({ search: e.target.value, offset: 0 }, () => this.updateOccupationList())}
					/>
					<Clear />
				</div>
				<div style={{ textAlign: "center", height: "auto", minHeight: 520 }}>
					{this.state.loading ?
						<CircularProgress /> :
						<div>{this.OccupationsTable()}</div>
					}
				</div>
			</Dialog>
		)
	}
}